export interface IDataMinerQueryFilters {
  address?: string;
  location?: string;
  geographyType?: string;
  utilityTerritory?: string;
  categories?: string[];
  areas?: string[];
  types?: string[];
  isDac?: boolean;
}

const parseBool = (value: string | null): boolean | undefined => {
  if (!value) return undefined;
  const normalized = value.trim().toLowerCase();
  if (["1", "true", "yes", "y"].includes(normalized)) return true;
  if (["0", "false", "no", "n"].includes(normalized)) return false;
  return undefined;
};

const splitList = (value: string | null): string[] | undefined => {
  if (!value) return undefined;
  const parts = value
    .split(/[|,]/g)
    .map((item) => item.trim())
    .filter(Boolean);
  return parts.length > 0 ? parts : undefined;
};

export const parseDataMinerQuery = (search: string): IDataMinerQueryFilters => {
  const params = new URLSearchParams(search);
  return {
    address: params.get("address") || undefined,
    location: params.get("location") || undefined,
    geographyType: params.get("geographyType") || undefined,
    utilityTerritory: params.get("utilityTerritory") || undefined,
    categories: splitList(params.get("categories")),
    areas: splitList(params.get("areas")),
    types: splitList(params.get("types")),
    isDac: parseBool(params.get("isDac")),
  };
};

export const buildDataMinerQuery = (filters: IDataMinerQueryFilters): string => {
  const params = new URLSearchParams();
  if (filters.address) params.set("address", filters.address);
  if (filters.location) params.set("location", filters.location);
  if (filters.geographyType) params.set("geographyType", filters.geographyType);
  if (filters.utilityTerritory) params.set("utilityTerritory", filters.utilityTerritory);
  if (filters.categories && filters.categories.length > 0) {
    params.set("categories", filters.categories.join("|"));
  }
  if (filters.areas && filters.areas.length > 0) {
    params.set("areas", filters.areas.join("|"));
  }
  if (filters.types && filters.types.length > 0) {
    params.set("types", filters.types.join("|"));
  }
  if (filters.isDac !== undefined) {
    params.set("isDac", filters.isDac ? "true" : "false");
  }
  const query = params.toString();
  return query.length > 0 ? `?${query}` : "";
};
